export interface IUserLoginResponse {
    accessToken: string;
    user: IUser;
}

export enum UserType {
    Admin = 'M',
    SalesManager = 'G',
    SalesRep = 'S',
}

export interface IUsersApi {
    total: number;
    limit: number;
    skip: number;
    data: IUser[];
}

export interface IUser {
    id: number;
    username: string;
    email?: string | null;
    name: string;
    slpcode: number;
    status: 1 | 0;
    type: UserType;
    maxActivity: number;
}

export interface IUserCreationInfo {
    username: string | null;
    name: string;
    password: string;
    type: string;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/interfaces/user.ts